import { pick } from 'ramda';

export default pick(['value']);
